export default {
  production: '6465d69904c24a62270abe63',
  development: '646399b4fea19f3ade3ac149',
  test: '646399b4fea19f3ade3ac149',
};
